module.exports = __webpack_public_path__ + "images/emoji/open_hands.84addde62ec842f1c55c.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/open_hands.png
// module id = 1ykO
// module chunks = 14